const config = {
    'API_URL': 'https://dev.silversky3d.com/api-levelup',
    'BASE_PATH': '',
    'VERSION': 'Version 20230726-14:05',
};

export default config;